import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import App from './App'
import InternalGate from './pages/InternalGate'
import { initErrorTracking } from './utils/errorTracking'
import './index.css'

// No-op unless VITE_SENTRY_DSN is set, so local and CI builds stay silent.
initErrorTracking()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <InternalGate><App /></InternalGate>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '14px',
            borderRadius: '12px',
            background: '#fff',
            color: '#1a2e26',
            boxShadow: '0 4px 16px rgba(10,61,46,0.12)',
          },
          success: {
            iconTheme: { primary: '#189e6d', secondary: '#fff' },
          },
          error: {
            iconTheme: { primary: '#ef4444', secondary: '#fff' },
          },
        }}
      />
    </BrowserRouter>
  </React.StrictMode>
)
